function startnumbers() {
  jQuery(".stats_list__item_number .number_counter:not(.counted)").each(function () {
    var $this = jQuery(this),
      countTo = $this.attr("data-count");
    $this.addClass("counted");
    jQuery({
      countNum: $this.text(),
    }).animate(
      {
        countNum: countTo,
      },
      {
        duration: 1000,
        easing: "linear",
        step: function () {
          $this.text(Math.ceil(this.countNum).toLocaleString("en"));
        },
        complete: function () {
          $this.text(this.countNum.toLocaleString("en"));
        },
      }
    );
  });
}
jQuery(document).ready(function () {
  jQuery(window).on("scroll", function () {
    if (jQuery(".mod-stats .stats_list").length > 0) {
      var numbers_section =
        jQuery(".mod-stats .stats_list").offset().top - window.innerHeight; ////  (jQuery(window).height() / 1.5)
      if (numbers_section < jQuery(window).scrollTop()) {
        startnumbers();
      }
    }
  });
});
